import {Box, Button, Typography} from '@viptech/react-components'
import {useState} from 'react'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {Input} from '../../../../../../../../components/input/Input'
import {ChosenObject} from '../../StepperModal'
import Card from '../../common/components/Card'
import {ContainerColumn} from './ConfigStepBase'

type Props = {
  chosen: ChosenObject | null
  amountOfDetectionSelected: string
  setAmountOfDetectionSelected: (value: string) => void
}

const ThresholdComponent = (props: Props) => {
  const {chosen, amountOfDetectionSelected, setAmountOfDetectionSelected} = props
  const {styledTheme} = usePersonalizedThemeByCompany()

  const amountOfDetection = ['1', '2', '3', '4', '5']

  const [showThresholdInput, setShowThresholdInput] = useState(chosen ? chosen.threshold > 5 : false)

  const TitleAndLabelComponent = ({title, label}: {title: string; label: string}) => {
    return (
      <Box>
        <Typography variant='span' size='16px' style={{fontWeight: 500}}>
          {title}
        </Typography>
        <Typography variant='p' size='12px' color='#8E8E8E'>
          {label}
        </Typography>
      </Box>
    )
  }
  const dontShowThresholdComponentTo = [
    'relatório de contagem',
    'facial',
    'placa',
    'epi',
    'reconhecimento facial',
    'análise demográfica',
    'leitura de placas',
    'veículos',
    'tempo de permanência',
    'animais',
    'objetos em geral',
  ]

  if (dontShowThresholdComponentTo.includes(chosen?.detectionTypeChosen?.toLowerCase() ?? '')) return <></>

  return (
    <Box align='center' justifyContent='center'>
      <TitleAndLabelComponent
        title={chosen?.detectionTypeChosen === 'Aglomeração' ? 'Personalize sua aglomeração' : 'Quantidade mínima'}
        label={
          chosen?.detectionTypeChosen === 'Aglomeração'
            ? 'Informe a quantidade mínima de pessoas necessárias para que ocorra o disparo. Escolha o número de pessoas que configuram uma aglomeração.'
            : 'Informe a quantidade que precisa ser detectada para ocorrer o disparo'
        }
      />

      <Box display='flex' columnGap='10px' align='center'>
        <ContainerColumn>
          {amountOfDetection.map((it) => {
            return (
              <Card
                dispatchTo={it}
                selected={amountOfDetectionSelected === it}
                initialState={!amountOfDetectionSelected}
                onClick={() => setAmountOfDetectionSelected(it)}
                key={it}
              />
            )
          })}
        </ContainerColumn>
        {!showThresholdInput ? (
          <Button
            fontSize='12px'
            height='40px'
            width='150px'
            color={styledTheme.colors.primary}
            variant='outlined'
            marginTop='18px'
            onClick={() => setShowThresholdInput(true)}>
            Digitar quantidade
          </Button>
        ) : (
          <Input.Root
            height='40px'
            width='150px'
            labelFontSize='12px'
            fontSize='12px'
            labelColor='#344054'
            marginTop='18px'
            defaultValue={amountOfDetectionSelected}
            value={amountOfDetectionSelected}
            onChange={(e) => setAmountOfDetectionSelected(e.target.value)}
            borderColor={styledTheme.colors.primary}
            mask={(value) => {
              if (+value <= 100 && value.match(/^-?([0-9]+)?$/)) return value
              return amountOfDetectionSelected
            }}
          />
        )}
      </Box>
    </Box>
  )
}

export default ThresholdComponent
